import { writable } from "svelte/store";

interface BookmarkedMessage {
  id: number;
  payload: string;
  createdAt: string;
  sessionId: number;
  messageId: number;
  senderId: string;
  showBorder: boolean;
}

const bookmarkedMessagesStoreCreate = () => {
  const {set, subscribe, update} = writable<Array<BookmarkedMessage>>([]);

  const generateBorder = (): void => {
    update((store) => {
      store.forEach((message, i): void => {
        if (i === store.length - 1) return;

        const nextMsg = store[i + 1];
        const isLastOfSender = nextMsg.senderId !== message.senderId;

        message.showBorder = isLastOfSender;
      });

      return store;
    });
  };

  return {set, subscribe, update, generateBorder};
};

const bookmarkedMessages = bookmarkedMessagesStoreCreate();

export {bookmarkedMessages};
